import type { Fragment } from '../translations';

export const fiche: Fragment = {
  fr: {
    'fiche.advance': 'Passer à l\'étape {n}',
    'fiche.advanceBlocked': 'Cases manquantes : {missing}',
    'fiche.return': 'Renvoyer',
    'fiche.returnTitle': 'Renvoyer à une étape antérieure',
    'fiche.returnMotif': 'Motif du renvoi (obligatoire)',
    'fiche.returnedBanner': 'Renvoyée depuis l\'étape {from} le {date} — motif : {motif}',
    'fiche.stageNotStarted': 'Cette étape n\'a pas commencé.',
    'fiche.reservedGovernance': 'Réservé à la gouvernance',
    'fiche.rolesInDiagram': 'Rôles dans ce diagramme',
    'fiche.rolesUnassigned': 'non attribué',
    'fiche.rolesNewLane': 'nouveau rôle',
    'fiche.rolesStale': 'couloir disparu du diagramme',
    'fiche.rolesPerson': 'Personne',
    'fiche.rolesFunction': 'Fonction',
    'fiche.rolesCapacity': 'Taux',
    'fiche.rolesConfirmed': 'Confirmé par',
    'fiche.diagramNone': 'Aucun diagramme lié à ce processus.',
    'fiche.diagramPick': 'Choisir un fichier du répertoire',
    'fiche.diagramEmpty': 'Ce fichier est vide — le modèle reste à faire.',
    'fiche.diagramStart': 'Commencer le diagramme',
    'fiche.diagramError': 'Le diagramme n\'a pas pu être chargé.',
    'fiche.diagramLoading': 'Chargement du diagramme…',
    'fiche.diagramConflict': 'Le diagramme a changé dans GitHub depuis votre ouverture (commit {sha} par {author}).',
    'fiche.diagramReload': 'Recharger',
    'fiche.download': 'Télécharger .bpmn',
    'fiche.fullscreen': 'Plein écran',
    'fiche.zoomIn': 'Zoom +',
    'fiche.zoomOut': 'Zoom −',
    'fiche.fit': 'Ajuster',
    'fiche.paused': 'Processus en pause',
    'fiche.cancelled': 'Processus annulé',
    'fiche.commitMessage': 'Message du commit',
    'fiche.savedToRepo': 'Enregistré — commit {sha}',
    'fiche.localReadonly': 'Mode développement : dépôt en lecture seule',
    'fiche.noCycleTitle': 'Ce processus est documenté mais n\'est pas passé par le cycle CdE.',
    'fiche.lastModified': 'Dernière modification',
    'fiche.lanes': 'Couloirs (rôles)',
    'fiche.commits': 'Historique des commits',
    'fiche.p1.title': 'Réception',
    'fiche.p1.client': 'Client',
    'fiche.p1.consultant': 'Consultant CdE',
    'fiche.p1.owner': 'Responsable du processus',
    'fiche.p1.horizon': 'Horizon',
    'fiche.p1.horizonStart': 'Début',
    'fiche.p1.horizonEnd': 'Fin',
    'fiche.p1.systemImpact': 'Impact système',
    'fiche.p1.impact.none': 'Aucun',
    'fiche.p1.impact.new_system': 'Nouveau système nécessaire',
    'fiche.p1.impact.adapt_system': 'Adaptation d\'un système',
    'fiche.p1.kind': 'Type',
    'fiche.p1.kind.new': 'Nouveau processus',
    'fiche.p1.kind.rework': 'Refonte',
    'fiche.p1.reworks': 'Processus remplacé',
    'fiche.p1.location': 'Emplacement prévu',
    'fiche.p1.origin': 'Origine',
    'fiche.p1.originPmo': 'Issu du projet PMO {project} (livrable {deliverable})',
    'fiche.p1.originTicket': 'Ouvert depuis le ticket #{id}',
    'fiche.p1.originCde': 'Créé au CdE',
    'fiche.p1.description': 'Description du processus',
    'fiche.p1.goal': 'Objectif',
    'fiche.p2.title': 'Collaboration client',
    'fiche.p2.addSeance': 'Nouvelle séance',
    'fiche.p2.seanceDate': 'Date de la séance',
    'fiche.p2.seanceKind': 'Type',
    'fiche.p2.kind.kickoff': 'Kick-Off',
    'fiche.p2.kind.presentation': 'Présentation au client',
    'fiche.p2.kind.kpi': 'Séance KPI',
    'fiche.p2.kind.note': 'Note',
    'fiche.p2.participants': 'Participants',
    'fiche.p2.notes': 'Notes de séance',
    'fiche.p2.transcript': 'Transcription',
    'fiche.p2.transcriptPending': 'transcription en cours…',
    'fiche.p2.transcriptFailed': 'la transcription a échoué',
    'fiche.p2.transcriptRetry': 'Relancer',
    'fiche.p2.transcriptWords': '{n} mots',
    'fiche.p2.audioTodo': 'Note audio (Speakr non configuré)',
    'fiche.p2.linkedCommit': 'Diagramme à cette date',
    'fiche.p2.viewVersion': 'voir cette version dans le diagramme',
    'fiche.p2.empty': 'Aucune séance pour l\'instant. La première séance avec le client démarre le journal.',
    'fiche.p2.satisfying': 'Résultat satisfaisant ?',
    'fiche.p2.satisfyingYes': 'Oui → étape 3',
    'fiche.p2.satisfyingNo': 'Non → nouvelle itération',
    'fiche.p3.title': 'Validation CdE',
    'fiche.p3.validatedWith': 'Validé avec',
    'fiche.p3.validatedWithHint': 'La seconde paire d\'yeux du CdE, prescrite par le processus.',
    'fiche.p3.needAdjust': 'Besoin d\'ajustements ?',
    'fiche.p3.sendBack': 'Renvoyer en collaboration',
    'fiche.p4.title': 'KPIs & dashboards',
    'fiche.p4.kpis': 'KPIs',
    'fiche.p4.dashboards': 'Dashboards',
    'fiche.p4.addKpi': 'Ajouter un KPI',
    'fiche.p4.addDashboard': 'Ajouter un dashboard',
    'fiche.p4.reuseShared': 'Reprendre un KPI existant',
    'fiche.p4.usedBy': 'utilisé par {names}',
    'fiche.p4.inherit': 'Reprendre les KPIs de {code}',
    'fiche.p4.inheritDone': 'KPIs et dashboards repris de {code}.',
    'fiche.p4.kpiName': 'Nom du KPI',
    'fiche.p4.kpiDef': 'Définition',
    'fiche.p4.kpiUnit': 'Unité',
    'fiche.p4.kpiTarget': 'Cible',
    'fiche.p4.kpiSource': 'Système source',
    'fiche.p4.shared': 'Partageable',
    'fiche.p4.dashName': 'Nom du dashboard',
    'fiche.p4.dashUrl': 'URL',
    'fiche.p4.gatePreview': 'La gouvernance vérifiera :',
    'fiche.p4.noKpis': 'Aucun KPI défini.',
    'fiche.p4.figuresReserved': 'Les chiffres des KPIs sont réservés au CdE et à la gouvernance.',
    'fiche.p4.noDashboards': 'Aucun dashboard défini.',
    'fiche.p5.title': 'Validation gouvernance',
    'fiche.p5.waiting': 'En attente de la gouvernance depuis {n} jours',
    'fiche.p5.remind': 'Relancer',
    'fiche.p5.reminded': 'Relance envoyée.',
    'fiche.p5.sendBack': 'Renvoyer au CdE',
    'fiche.p5.inventoryNote': 'Cocher cette case fait entrer le processus dans l\'inventaire officiel.',
    'fiche.p6.title': 'Validation finale CdE',
    'fiche.p6.recap': 'Récapitulatif',
    'fiche.p6.recapRoles': '{assigned}/{total} rôles attribués',
    'fiche.p6.recapKpis': '{n} KPIs définis',
    'fiche.p6.recapDashboards': '{n} dashboards',
    'fiche.p6.recapSeances': '{n} séances',
    'fiche.p6.recapTickets': '{n} tickets ouverts',
    'fiche.p6.recapCommit': 'diagramme au commit {sha}',
    'fiche.p7.title': 'Passage aux systèmes',
    'fiche.p7.honest': 'Le workflow Systèmes n\'est pas encore un outil. Cette étape enregistre la passation.',
    'fiche.p7.target': 'Système cible',
    'fiche.p7.contact': 'Contact',
    'fiche.p7.date': 'Date de passation',
    'fiche.p7.link': 'Lien',
    'fiche.p7.handover': 'Générer le handover',
    'fiche.p8.title': 'Processus en service',
    'fiche.p8.since': 'En service depuis',
    'fiche.p8.openTickets': 'Tickets ouverts',
    'fiche.p8.openRework': 'Ouvrir une refonte',
    'fiche.p8.reworkBanner': 'Une refonte est en cours ({code}, étape {n}).',
    'fiche.reworkOf': 'Refonte de {code}',
    'fiche.pausedBanner': 'Processus en pause — {reason}',
    'fiche.checkedBy': 'cochée le {date} par {name}',
    'fiche.checkNote': 'Note',
    'fiche.gateOwnerCde': 'Validé par le Centre d\'Excellence',
    'fiche.gateOwnerGov': 'Validé par la gouvernance',
    'fiche.evidence.opened': 'ouvert le {date}',
    'fiche.evidence.seances': '{seances} séances · {versions} versions',
    'fiche.evidence.validated': 'validée le {date}',
    'fiche.widenPanel': 'élargir',
    'fiche.narrowPanel': 'réduire',
  },
  en: {
    'fiche.advance': 'Advance to step {n}',
    'fiche.advanceBlocked': 'Missing checks: {missing}',
    'fiche.return': 'Send back',
    'fiche.returnTitle': 'Send back to an earlier step',
    'fiche.returnMotif': 'Reason (required)',
    'fiche.returnedBanner': 'Sent back from step {from} on {date} — reason: {motif}',
    'fiche.stageNotStarted': 'This step has not started.',
    'fiche.reservedGovernance': 'Reserved to governance',
    'fiche.rolesInDiagram': 'Roles in this diagram',
    'fiche.rolesUnassigned': 'unassigned',
    'fiche.rolesNewLane': 'new role',
    'fiche.rolesStale': 'lane no longer in the diagram',
    'fiche.rolesPerson': 'Person',
    'fiche.rolesFunction': 'Function',
    'fiche.rolesCapacity': 'Rate',
    'fiche.rolesConfirmed': 'Confirmed by',
    'fiche.diagramNone': 'No diagram linked to this process.',
    'fiche.diagramPick': 'Pick a file from the repository',
    'fiche.diagramEmpty': 'This file is empty — the model remains to be made.',
    'fiche.diagramStart': 'Start the diagram',
    'fiche.diagramError': 'The diagram could not be loaded.',
    'fiche.diagramLoading': 'Loading the diagram…',
    'fiche.diagramConflict': 'The diagram changed in GitHub since you opened it (commit {sha} by {author}).',
    'fiche.diagramReload': 'Reload',
    'fiche.download': 'Download .bpmn',
    'fiche.fullscreen': 'Full screen',
    'fiche.zoomIn': 'Zoom in',
    'fiche.zoomOut': 'Zoom out',
    'fiche.fit': 'Fit',
    'fiche.paused': 'Process on hold',
    'fiche.cancelled': 'Process cancelled',
    'fiche.commitMessage': 'Commit message',
    'fiche.savedToRepo': 'Saved — commit {sha}',
    'fiche.localReadonly': 'Development mode: repository is read-only',
    'fiche.noCycleTitle': 'This process is documented but has not been through the CdE cycle.',
    'fiche.lastModified': 'Last modified',
    'fiche.lanes': 'Lanes (roles)',
    'fiche.commits': 'Commit history',
    'fiche.p1.title': 'Intake',
    'fiche.p1.client': 'Client',
    'fiche.p1.consultant': 'CdE consultant',
    'fiche.p1.owner': 'Process owner',
    'fiche.p1.horizon': 'Horizon',
    'fiche.p1.horizonStart': 'Start',
    'fiche.p1.horizonEnd': 'End',
    'fiche.p1.systemImpact': 'System impact',
    'fiche.p1.impact.none': 'None',
    'fiche.p1.impact.new_system': 'New system needed',
    'fiche.p1.impact.adapt_system': 'System adaptation',
    'fiche.p1.kind': 'Type',
    'fiche.p1.kind.new': 'New process',
    'fiche.p1.kind.rework': 'Rework',
    'fiche.p1.reworks': 'Replaced process',
    'fiche.p1.location': 'Intended location',
    'fiche.p1.origin': 'Origin',
    'fiche.p1.originPmo': 'From PMO project {project} (deliverable {deliverable})',
    'fiche.p1.originTicket': 'Opened from ticket #{id}',
    'fiche.p1.originCde': 'Created at the CdE',
    'fiche.p1.description': 'Process description',
    'fiche.p1.goal': 'Goal',
    'fiche.p2.title': 'Client work',
    'fiche.p2.addSeance': 'New session',
    'fiche.p2.seanceDate': 'Session date',
    'fiche.p2.seanceKind': 'Type',
    'fiche.p2.kind.kickoff': 'Kick-off',
    'fiche.p2.kind.presentation': 'Client presentation',
    'fiche.p2.kind.kpi': 'KPI session',
    'fiche.p2.kind.note': 'Note',
    'fiche.p2.participants': 'Participants',
    'fiche.p2.notes': 'Session notes',
    'fiche.p2.transcript': 'Transcript',
    'fiche.p2.transcriptPending': 'transcription in progress…',
    'fiche.p2.transcriptFailed': 'transcription failed',
    'fiche.p2.transcriptRetry': 'Retry',
    'fiche.p2.transcriptWords': '{n} words',
    'fiche.p2.audioTodo': 'Audio note (Speakr not configured)',
    'fiche.p2.linkedCommit': 'Diagram at this date',
    'fiche.p2.viewVersion': 'view this version in the diagram',
    'fiche.p2.empty': 'No sessions yet. The first client session starts the journal.',
    'fiche.p2.satisfying': 'Satisfying result?',
    'fiche.p2.satisfyingYes': 'Yes → step 3',
    'fiche.p2.satisfyingNo': 'No → next iteration',
    'fiche.p3.title': 'CdE validation',
    'fiche.p3.validatedWith': 'Validated with',
    'fiche.p3.validatedWithHint': 'The CdE\'s second pair of eyes, as the process prescribes.',
    'fiche.p3.needAdjust': 'Adjustments needed?',
    'fiche.p3.sendBack': 'Send back to client work',
    'fiche.p4.title': 'KPIs & dashboards',
    'fiche.p4.kpis': 'KPIs',
    'fiche.p4.dashboards': 'Dashboards',
    'fiche.p4.addKpi': 'Add a KPI',
    'fiche.p4.addDashboard': 'Add a dashboard',
    'fiche.p4.reuseShared': 'Reuse an existing KPI',
    'fiche.p4.usedBy': 'used by {names}',
    'fiche.p4.inherit': 'Inherit KPIs from {code}',
    'fiche.p4.inheritDone': 'KPIs and dashboards inherited from {code}.',
    'fiche.p4.kpiName': 'KPI name',
    'fiche.p4.kpiDef': 'Definition',
    'fiche.p4.kpiUnit': 'Unit',
    'fiche.p4.kpiTarget': 'Target',
    'fiche.p4.kpiSource': 'Source system',
    'fiche.p4.shared': 'Shareable',
    'fiche.p4.dashName': 'Dashboard name',
    'fiche.p4.dashUrl': 'URL',
    'fiche.p4.gatePreview': 'Governance will check:',
    'fiche.p4.noKpis': 'No KPI defined.',
    'fiche.p4.figuresReserved': 'KPI figures are reserved to the CdE and governance.',
    'fiche.p4.noDashboards': 'No dashboard defined.',
    'fiche.p5.title': 'Governance sign-off',
    'fiche.p5.waiting': 'Waiting for governance for {n} days',
    'fiche.p5.remind': 'Remind',
    'fiche.p5.reminded': 'Reminder sent.',
    'fiche.p5.sendBack': 'Send back to the CdE',
    'fiche.p5.inventoryNote': 'Ticking this box adds the process to the official inventory.',
    'fiche.p6.title': 'Final CdE validation',
    'fiche.p6.recap': 'Recap',
    'fiche.p6.recapRoles': '{assigned}/{total} roles assigned',
    'fiche.p6.recapKpis': '{n} KPIs defined',
    'fiche.p6.recapDashboards': '{n} dashboards',
    'fiche.p6.recapSeances': '{n} sessions',
    'fiche.p6.recapTickets': '{n} open tickets',
    'fiche.p6.recapCommit': 'diagram at commit {sha}',
    'fiche.p7.title': 'Pass to systems',
    'fiche.p7.honest': 'The Systems workflow is not a tool yet. This step records the handover.',
    'fiche.p7.target': 'Target system',
    'fiche.p7.contact': 'Contact',
    'fiche.p7.date': 'Handover date',
    'fiche.p7.link': 'Link',
    'fiche.p7.handover': 'Generate the handover',
    'fiche.p8.title': 'Process live',
    'fiche.p8.since': 'Live since',
    'fiche.p8.openTickets': 'Open tickets',
    'fiche.p8.openRework': 'Open a rework',
    'fiche.p8.reworkBanner': 'A rework is in progress ({code}, step {n}).',
    'fiche.reworkOf': 'Rework of {code}',
    'fiche.pausedBanner': 'Process on hold — {reason}',
    'fiche.checkedBy': 'ticked on {date} by {name}',
    'fiche.checkNote': 'Note',
    'fiche.gateOwnerCde': 'Validated by the Centre of Excellence',
    'fiche.gateOwnerGov': 'Validated by governance',
    'fiche.evidence.opened': 'opened on {date}',
    'fiche.evidence.seances': '{seances} sessions · {versions} versions',
    'fiche.evidence.validated': 'validated on {date}',
    'fiche.widenPanel': 'widen',
    'fiche.narrowPanel': 'narrow',
  },
};
